import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=BUYBOX_EXP_2:control
// ?preferred_variant=BUYBOX_EXP_2:variant_1
// ?preferred_variant=BUYBOX_EXP_2:variant_2

export const BuyboxExp2Name = 'BUYBOX_EXP_2' as const;

export type BuyboxExp2Variants = ToVariants<typeof BuyboxExp2Variants>;

export const BuyboxExp2Variants = {
	/** Current BuyBox */
	CONTROL: 'control',
	/** Last V2 (winner) with filter below promoted buybox */
	VARIANT_1: 'variant_1',
	/** Free trial additions/changes */
	VARIANT_2: 'variant_2',
} as const;

export default generate(BuyboxExp2Name, BuyboxExp2Variants, (instance: any) => {
	return (
		!instance?.activeVariantsWithControlGroup['POPULAR-PROVIDER-PAGE-EXP_4'] ||
		!instance?.activeVariantsWithControlGroup['APPLE_FREE_TRIAL_FEATURE_EXP_2']
	);
});
